import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  initialize(measurementId: string): void {
    if (isPlatformBrowser(this.platformId)) {
      this.injectScript(measurementId);
      this.trackRouteChanges(measurementId);
    }
  }

  private injectScript(measurementId: string): void {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).gtag = function() { (window as any).dataLayer.push(arguments); };
    (window as any).gtag('js', new Date());
    (window as any).gtag('config', measurementId);

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
    document.head.appendChild(script);
  }

  private trackRouteChanges(measurementId: string): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        const navEnd = event as NavigationEnd;
        (window as any).gtag('config', measurementId, {
          page_path: navEnd.urlAfterRedirects,
          page_title: this.resolvePageTitle()
        });
      });
  }

  private resolvePageTitle(): string {
    let route = this.activatedRoute;
    while (null != route.firstChild) {
      route = route.firstChild;
    }
    const routeTitle = route.snapshot.title;
    let result = (null != routeTitle) ? routeTitle : '';
    if ('' === result) {
      result = document.title;
    }
    return result;
  }
}
